import React, { useState } from 'react';
import styles from './style.module.css';
import CopySvg from "../icons/copy";
import SuccessSvg from "../icons/success";

interface CopyTextProps {
  text: string;
  variant?: 'withBackground' | 'withoutBackground';
  showTooltip?: boolean;
  tooltipText?: string;
  copiedTooltipText?: string;
  className?: string;
  textClassName?: string;
  onCopy?: (text: string) => void;
}

const CopyText: React.FC<CopyTextProps> = ({
                                             text,
                                             variant = 'withBackground',
                                             showTooltip = true,
                                             tooltipText = '',
                                             copiedTooltipText = '',
                                             className = '',
                                             textClassName = '',
                                             onCopy,
                                           }) => {
  const [copied, setCopied] = useState(false);
  const [isHovering, setIsHovering] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();

    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);

      if (onCopy) {
        onCopy(text);
      }
      setTimeout(() => {
        setCopied(false);
      }, 5000);
    } catch (err) {
      console.error('Ошибка копирования:', err);
      // Fallback для старых браузеров
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
    }
  };

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  return (
    <div
      className={`${styles.copyContainer} ${styles[variant]} ${className}`}
      onClick={handleCopy}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleCopy(e as any);
        }
      }}
      title={showTooltip ? (copied ? copiedTooltipText : tooltipText) : undefined}
    >
      <span className={`${styles.text} ${textClassName}`}>
        {text}
      </span>

      {showTooltip && isHovering && tooltipText && !copied && (
        <div className={styles.tooltip}>
          {tooltipText}
        </div>
      )}

      {showTooltip && isHovering && copiedTooltipText && copied && (
        <div className={styles.tooltip}>
          {copiedTooltipText}
        </div>
      )}

      <div className={copied ? styles.checkIcon : styles.copyIcon}>
        {copied ? (
          <SuccessSvg />
        ) : (
          <CopySvg />
        )}
      </div>
    </div>
  );
};

export default CopyText;